export enum HighlightedFeatureStatusEnum {
	INTRODUCTION = 'introduction',
	FILTER = 'filter',
	MASS_EDIT = 'massEdit',
	SEARCH = 'search',
	INACTIVE = 'inactive'
}
